import { useEffect, useState } from "react";
import { Phone, ScanLine } from "lucide-react";
import { Logo, Wordmark } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, SCAN_URL, scrollToId } from "../lib/site";

const LINKS = [
  { id: "threat", label: "The Threat" },
  { id: "scan", label: "Free Scan" },
  { id: "how", label: "How It Works" },
  { id: "toolbar", label: "Toolbar" },
  { id: "faq", label: "FAQ" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ink/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <button data-testid="nav-logo-home" onClick={() => scrollToId("top")} className="flex items-center gap-3 text-left">
          <Logo className="h-9 w-9" />
          <Wordmark />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-mono text-xs uppercase tracking-[0.18em] text-slate-300 hover:text-brandamber transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-call-phone-btn"
            href={PHONE_TEL}
            className="hidden sm:inline-flex items-center gap-2 rounded-full border border-cy/40 px-4 py-2 font-mono text-xs tracking-wider text-cy transition-all hover:bg-cy/10 hover:border-cy"
          >
            <Phone className="h-3.5 w-3.5" /> {PHONE_DISPLAY}
          </a>
          <a
            data-testid="nav-free-scan-btn"
            href={SCAN_URL}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brandamber px-4 sm:px-5 py-2 font-bold text-sm text-ink shadow-md shadow-brandamber/30 transition-transform hover:scale-[1.06] active:scale-95"
          >
            <ScanLine className="h-4 w-4" /> Free Scan
          </a>
        </div>
      </div>
    </header>
  );
};
